import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { HockeyStatistic, TeamUserRole, TeamUserRoleLocalization, TournamentTeamUser } from '@mtgame/core';
import { getLeaguePlayerRoute } from '@config/routes';

@Component({
  selector: 'mtg-tournament-team-staff',
  templateUrl: './tournament-team-staff.component.html',
  styleUrls: ['./tournament-team-staff.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentTeamStaffComponent implements OnInit, OnChanges {
  @Input()
  title: string;
  @Input()
  staffType: 'captains' | 'leadership' | 'coach';
  @Input()
  statistic: HockeyStatistic[];
  @Input()
  users: TournamentTeamUser[];
  staff: TournamentTeamUser[] = [];
  teamUserRolesLocalization = TeamUserRoleLocalization;

  ngOnInit(): void {
    this.getStaff();
  }

  ngOnChanges(): void {
    this.getStaff();
  }

  getUserRoute(leaguePlayerId: number): string[] {
    return getLeaguePlayerRoute(leaguePlayerId);
  }

  getStaff() {
    const coachSortRoles = {
      5 : 1, // head_coach
      15 : 2, // senior_coach
      4 : 3, // coach
      16 : 4, // assistant_coach
      6 : 5, // playing_coach
    };
    let staffRoles;
    if (this.staffType === 'captains') {
      staffRoles = [TeamUserRole.captain, TeamUserRole.assistant, TeamUserRole.serviceman];
    }
    if (this.staffType === 'leadership') {
      staffRoles = [TeamUserRole.manager, TeamUserRole.head_manager, TeamUserRole.executive, TeamUserRole.press_attache, TeamUserRole.vice_president, TeamUserRole.president];
    }
    if (this.staffType === 'coach') {
      staffRoles = [TeamUserRole.coach, TeamUserRole.head_coach, TeamUserRole.playing_coach, TeamUserRole.senior_coach, TeamUserRole.assistant_coach];
    }
    this.staff = this.users.filter(item => staffRoles.indexOf(item.teamUser.role) > -1)
      .sort((a, b) => {
        if (this.staffType === 'coach') {

          const aRoleSort = coachSortRoles[a.teamUser.role];
          const bRoleSort = coachSortRoles[b.teamUser.role];
          return aRoleSort < bRoleSort ? -1 : 1;
        }
        return a.teamUser.role < b.teamUser.role ? -1 : 1;
      });
  }
}
